(function () {
  var cfg = window.__terminalCfg;
  if (!cfg) return;

  var SPEED = cfg.speed || 30;
  var COLOR = cfg.color || '#34D104';

  var baseStyle = document.createElement('style');
  baseStyle.textContent =
    '.terminal-heading-active{font-family:"VCR OSD Mono","Courier New",monospace!important;' +
    'color:' + COLOR + '!important;letter-spacing:.12em!important;text-transform:uppercase!important;overflow:visible!important;}' +
    '.terminal-span{display:inline-block;overflow:hidden;white-space:nowrap;clip-path:inset(0 100% 0 0);}' +
    '.terminal-cursor{display:inline-block;color:' + COLOR + ';font-family:"VCR OSD Mono","Courier New",monospace;' +
    'margin-left:2px;vertical-align:bottom;animation:terminal-blink .8s step-end infinite;}' +
    '@keyframes terminal-blink{0%,100%{opacity:1}50%{opacity:0}}';
  document.head.appendChild(baseStyle);

  function uid() { return 'te' + Math.random().toString(36).slice(2, 8); }

  function applyTo(el) {
    if (el.dataset.terminalDone) return;
    el.dataset.terminalDone = '1';
    var text = el.textContent.trim().toUpperCase();
    if (!text) return;
    var n = text.length;
    var dur = (n * SPEED / 1000).toFixed(3);
    var id = uid();
    var kf = document.createElement('style');
    kf.textContent =
      '.te-' + id + '{animation:' + id + ' ' + dur + 's steps(' + n + ',end) forwards;}' +
      '@keyframes ' + id + '{to{clip-path:inset(0 0% 0 0)}}';
    document.head.appendChild(kf);
    el.classList.add('terminal-heading-active');
    el.innerHTML =
      '<span class="terminal-span te-' + id + '">' + text + '</span>' +
      '<span class="terminal-cursor">|</span>';
  }

  function observe(el) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); applyTo(el); }
      }, { threshold: 0.15 });
      io.observe(el);
    } else {
      applyTo(el);
    }
  }

  /* Find the first visible heading inside a container */
  function findHeading(container) {
    return container.querySelector('h1,h2,h3,h4,.page-title,.section-heading,.secondary-heading,.custom-heading');
  }

  function scan(root) {
    /* Section-level terminal containers */
    (root || document).querySelectorAll('[data-terminal-section]').forEach(function (container) {
      var h = findHeading(container);
      if (h) observe(h);
    });
    /* Block-level terminal containers */
    (root || document).querySelectorAll('[data-terminal-block]').forEach(function (container) {
      var h = findHeading(container);
      if (h) observe(h);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (section) {
      section.querySelectorAll('[data-terminal-done]').forEach(function (el) {
        delete el.dataset.terminalDone;
      });
      scan(section);
    }
  });
})();
